import { PROGRAM_CONTEXT_CHANGE, PROGRAM_LIST_LOAD } from '../types/programTypes';

export const setProgramsList = programsList => dispatch =>
  dispatch({ type: PROGRAM_LIST_LOAD, result: { programsList } });

export const setProgramContext = programId => dispatch =>
  dispatch({ type: PROGRAM_CONTEXT_CHANGE, result: { programId } });



// WEBPACK FOOTER //
// ./src/redux/actions/financial/programContextActions.js